module.exports = __webpack_public_path__ + "static/media/ebay.1b0d852d.png";